import { selectIsUserLoggedIn } from "@/constants/auth/auth";
import useAuth from "@/hooks/useAuth";
import usePermissions from "@/config/usePermissions";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";

export const ProtectedRoute = ({ redirectPath = "/admin-auth" }) => {
  const isAuthenticated = useSelector(selectIsUserLoggedIn);
  const location = useLocation();

  const auth = useAuth();
  // console.log("ProtectedRoute - isAuthenticated:", isAuthenticated, "auth:", auth, "location:", location);
  if (!isAuthenticated) {
    localStorage.setItem("auth_lastPath", location.pathname + location.search);
    return (
      <Navigate
        to={redirectPath}
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }

  return <Outlet />;
};

export const PermissionRoute = ({ permissionName, redirectPath }) => {
  const isAuthenticated = useSelector(selectIsUserLoggedIn);
  const location = useLocation();
  const { checkPermission, defaultRoute } = usePermissions();

  // First check if authenticated
  if (!isAuthenticated) {
    localStorage.setItem("auth_lastPath", location.pathname + location.search);
    return (
      <Navigate
        to="/admin-auth"
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }

  // Then check if user has the required permission
  if (!checkPermission(permissionName)) {
    // If no redirect path specified, use user's default accessible route
    const finalRedirectPath = redirectPath || defaultRoute || "/admin/notfound";
    return <Navigate to={finalRedirectPath} replace />;
  }

  return <Outlet />;
};
